export const categories = [
  {
    slug: 'yule-mingxing',
    name: '娱乐明星',
    description: '娱乐圈最新八卦、明星私生活爆料、影视综艺内幕',
    icon: 'ri-star-line',
  },
  {
    slug: 'wanghong-zhubo',
    name: '网红主播',
    description: '各大平台网红塌房现场、主播翻车实录、直播圈秘闻',
    icon: 'ri-live-line',
  },
  {
    slug: 'shehui-redian',
    name: '社会热点',
    description: '热搜事件深度追踪、社会黑料第一手掌握',
    icon: 'ri-fire-line',
  },
  {
    slug: 'dianshi-zongyi',
    name: '电视综艺',
    description: '热门综艺幕后故事、选秀节目不为人知的秘密',
    icon: 'ri-tv-line',
  },
  {
    slug: 'dujia-bagua',
    name: '独家八卦',
    description: '吃瓜网独家爆料、一手消息抢先看',
    icon: 'ri-spy-line',
  },
  {
    slug: 'hulianwang',
    name: '互联网圈',
    description: '科技大佬恩怨情仇、互联网公司内部猛料',
    icon: 'ri-global-line',
  },
];

export const articles = [
  {
    id: 1,
    title: '某顶流男星深夜私会神秘女子，酒店共度八小时',
    slug: 'dingliu-nanxing-siwei-shenmi-nvzi',
    category: '娱乐明星',
    categorySlug: 'yule-mingxing',
    excerpt: '据知情人士透露，某当红顶流男星近日被拍到深夜与一名神秘女子前后进入某五星级酒店，直至次日清晨才分别离开，引发粉丝热议...',
    imageQuery: 'A luxurious hotel entrance at night with paparazzi-style photography, dramatic lighting, blurred figure walking in, cinematic composition, warm amber street lights, mysterious atmosphere, editorial magazine quality, high contrast shadows',
    imageWidth: 800,
    imageHeight: 500,
    imageSeq: 'article-img-01',
    publishedAt: '2026-07-05',
    views: 128930,
    comments: 3456,
    tags: ['顶流', '恋情', '酒店', '偷拍'],
    content: '',
    source: '吃瓜网独家',
  },
  {
    id: 2,
    title: '知名带货主播直播间翻车，假货风波持续发酵',
    slug: 'zhiming-daihuo-zhibo-fanche',
    category: '网红主播',
    categorySlug: 'wanghong-zhubo',
    excerpt: '拥有千万粉丝的某带货主播在近日直播中售卖的高端护肤品被消费者质疑为假货，品牌方已发表声明否认与该主播有合作关系...',
    imageQuery: 'A modern live streaming studio setup with professional lighting equipment, smartphone on tripod, beauty products scattered on table, slightly chaotic atmosphere, warm indoor lighting, documentary style photography, shallow depth of field',
    imageWidth: 800,
    imageHeight: 500,
    imageSeq: 'article-img-02',
    publishedAt: '2026-07-05',
    views: 95670,
    comments: 2891,
    tags: ['直播带货', '假货', '翻车', '维权'],
    content: '',
    source: '网友投稿',
  },
  {
    id: 3,
    title: '娱乐圈又一对神仙眷侣疑似婚变，双方已取关',
    slug: 'yulequan-hunbian-quguan',
    category: '娱乐明星',
    categorySlug: 'yule-mingxing',
    excerpt: '曾被誉为娱乐圈模范夫妻的某明星夫妇近期被网友发现在社交平台互相取关，且已数月无公开互动，婚变传闻甚嚣尘上...',
    imageQuery: 'Two smartphones displaying social media profiles with unfollow buttons visible, soft moody lighting, melancholy atmosphere, editorial photography style, warm desaturated tones, intimate composition',
    imageWidth: 800,
    imageHeight: 500,
    imageSeq: 'article-img-03',
    publishedAt: '2026-07-04',
    views: 156420,
    comments: 5678,
    tags: ['婚变', '明星夫妻', '取关', '娱乐圈'],
    content: '',
    source: '网络综合',
  },
  {
    id: 4,
    title: '某选秀节目导演组内幕曝光：淘汰名单早有内定',
    slug: 'xuanxiu-dao-yan-zu-nei-mu',
    category: '电视综艺',
    categorySlug: 'dianshi-zongyi',
    excerpt: '一位自称曾参与某大型选秀节目制作的工作人员匿名爆料，称节目中的淘汰名单早在录制前就已由导演组和赞助商共同敲定...',
    imageQuery: 'Behind the scenes of a TV studio with production equipment, lighting rigs, empty stage seats, dramatic spotlight, moody atmosphere, cinematic documentary style, contrasty lighting, warm and cool tones mix',
    imageWidth: 800,
    imageHeight: 500,
    imageSeq: 'article-img-04',
    publishedAt: '2026-07-04',
    views: 88750,
    comments: 2134,
    tags: ['选秀', '内幕', '导演组', '黑幕'],
    content: '',
    source: '匿名投稿',
  },
  {
    id: 5,
    title: '科技圈大佬私人饭局录音泄露，惊人言论引争议',
    slug: 'keji-quan-dalao-fanju-luyin',
    category: '互联网圈',
    categorySlug: 'hulianwang',
    excerpt: '一段疑似某知名科技公司创始人在私人饭局上的录音近日在网络流传，其中涉及对竞争对手的激烈言论和对行业未来的大胆预测...',
    imageQuery: 'An upscale private dining room in a high-end Chinese restaurant, round table with dishes, dim warm lighting, recording device subtly placed, suspenseful atmosphere, cinematic photography, rich amber tones',
    imageWidth: 800,
    imageHeight: 500,
    imageSeq: 'article-img-05',
    publishedAt: '2026-07-03',
    views: 201450,
    comments: 8923,
    tags: ['科技圈', '录音', '争议', '大佬'],
    content: '',
    source: '网络爆料',
  },
  {
    id: 6,
    title: '知名女星整容前后对比照疯传，网友直呼认不出',
    slug: 'zhiming-nvxing-zhengrong-duibi',
    category: '娱乐明星',
    categorySlug: 'yule-mingxing',
    excerpt: '一组疑似某知名女星整容前后的对比照片在社交平台被疯狂转发，照片中面部轮廓变化明显，引发网友热议...',
    imageQuery: 'Split composition showing before and after concept, soft beauty clinic aesthetic, diffused lighting, elegant but dramatic comparison, editorial magazine style, warm peachy tones, professional photography',
    imageWidth: 800,
    imageHeight: 500,
    imageSeq: 'article-img-06',
    publishedAt: '2026-07-03',
    views: 178230,
    comments: 6543,
    tags: ['整容', '女星', '对比', '颜值'],
    content: '',
    source: '网友整理',
  },
  {
    id: 7,
    title: '某MCN机构内部聊天记录流出：如何操控网红人设',
    slug: 'mcn-jigou-neibu-jilu',
    category: '网红主播',
    categorySlug: 'wanghong-zhubo',
    excerpt: '一份据称来自国内某头部MCN机构的内部聊天记录被曝光，详细展示了他们如何从零包装打造网红人设的全过程...',
    imageQuery: 'A modern office workspace with multiple computer screens showing social media dashboards, scattered documents, dim desk lamp lighting, moody atmosphere, documentary style, warm tungsten light, late night working scene',
    imageWidth: 800,
    imageHeight: 500,
    imageSeq: 'article-img-07',
    publishedAt: '2026-07-02',
    views: 145600,
    comments: 4321,
    tags: ['MCN', '网红', '人设', '内幕'],
    content: '',
    source: '吃瓜网独家',
  },
  {
    id: 8,
    title: '热搜第一！某知名品牌代言人突然被替换内情',
    slug: 'resou-diyan-daiyanren-tihuan',
    category: '社会热点',
    categorySlug: 'shehui-redian',
    excerpt: '今日热搜榜首的某知名品牌突然宣布更换代言人引发广泛关注，据内部人士透露，背后原因竟与一桩未公开的官司有关...',
    imageQuery: 'A minimalist billboard being changed with brand advertisement, workers on ladder, urban street scene, dramatic sky, editorial photography, cinematic composition, warm sunset lighting',
    imageWidth: 800,
    imageHeight: 500,
    imageSeq: 'article-img-08',
    publishedAt: '2026-07-02',
    views: 267890,
    comments: 10234,
    tags: ['热搜', '代言人', '品牌', '官司'],
    content: '',
    source: '综合报道',
  },
  {
    id: 9,
    title: '某综艺节目录制现场突发冲突，嘉宾愤然离席',
    slug: 'zongyi-jie-mu-lu-zhi-chong-tu',
    category: '电视综艺',
    categorySlug: 'dianshi-zongyi',
    excerpt: '据现场观众爆料，某热门综艺节目最新一期录制过程中，两位常驻嘉宾因游戏环节发生激烈争执，其中一位直接摔话筒离场...',
    imageQuery: 'A TV studio set with bright stage lights, empty chairs, microphone on floor, dramatic tension atmosphere, cinematic lighting with strong contrast, editorial quality, warm and cool light mix',
    imageWidth: 800,
    imageHeight: 500,
    imageSeq: 'article-img-09',
    publishedAt: '2026-07-01',
    views: 134560,
    comments: 3876,
    tags: ['综艺', '冲突', '录制', '离席'],
    content: '',
    source: '现场观众',
  },
  {
    id: 10,
    title: '某知名企业高管被曝职场骚扰，多名女员工联合发声',
    slug: 'qiye-gaoguan-zhichang-saorao',
    category: '社会热点',
    categorySlug: 'shehui-redian',
    excerpt: '近日，某上市公司多位女性员工通过社交平台联合发文，指控该公司某高管存在长期职场骚扰行为，目前已引起相关部门关注...',
    imageQuery: 'A modern corporate office building exterior at dusk, dramatic sky, somber mood, reflective glass windows, urban landscape, editorial journalism photography, desaturated warm tones, powerful composition',
    imageWidth: 800,
    imageHeight: 500,
    imageSeq: 'article-img-10',
    publishedAt: '2026-07-01',
    views: 312450,
    comments: 15678,
    tags: ['职场骚扰', '高管', '女员工', '维权'],
    content: '',
    source: '多方核实',
  },
  {
    id: 11,
    title: '某流量小花片场耍大牌视频流出，导演当场发飙',
    slug: 'liuliang-xiaohua-shua-dapai',
    category: '独家八卦',
    categorySlug: 'dujia-bagua',
    excerpt: '一段据称在某古装剧拍摄现场偷拍的视频在网络疯传，视频中某当红小花对工作人员态度恶劣，导演忍无可忍当场发飙...',
    imageQuery: 'A historical Chinese drama film set with traditional costumes and props, behind the scenes chaos, dramatic confrontation moment, cinematic lighting, dusty atmosphere, warm sunset backlight, editorial photography',
    imageWidth: 800,
    imageHeight: 500,
    imageSeq: 'article-img-11',
    publishedAt: '2026-06-30',
    views: 189340,
    comments: 7890,
    tags: ['耍大牌', '片场', '小花', '导演'],
    content: '',
    source: '吃瓜网独家',
  },
  {
    id: 12,
    title: '某短视频平台头部博主被实锤造假，粉丝集体脱粉',
    slug: 'duan-shipin-bozhu-jia-zao',
    category: '网红主播',
    categorySlug: 'wanghong-zhubo',
    excerpt: '拥有三千万粉丝的某短视频平台头部博主被技术大神实锤视频内容造假，多个"生活记录"视频被扒出存在明显的拼接和摆拍痕迹...',
    imageQuery: 'A smartphone screen showing video editing timeline with visible cuts and edits, dramatic reveal moment, moody lighting, modern digital aesthetic, warm amber and cool blue contrast, editorial composition',
    imageWidth: 800,
    imageHeight: 500,
    imageSeq: 'article-img-12',
    publishedAt: '2026-06-30',
    views: 223100,
    comments: 12345,
    tags: ['造假', '脱粉', '实锤', '博主'],
    content: '',
    source: '技术分析',
  },
];

export const trendingTopics = [
  { name: '顶流男星酒店私会', count: 128930, slug: 'dingliu-nanxing-siwei-shenmi-nvzi' },
  { name: '带货主播假货风波', count: 95670, slug: 'zhiming-daihuo-zhibo-fanche' },
  { name: '明星夫妻婚变', count: 156420, slug: 'yulequan-hunbian-quguan' },
  { name: '科技大佬饭局录音', count: 201450, slug: 'keji-quan-dalao-fanju-luyin' },
  { name: '女星整容对比', count: 178230, slug: 'zhiming-nvxing-zhengrong-duibi' },
  { name: '高管职场骚扰', count: 312450, slug: 'qiye-gaoguan-zhichang-saorao' },
  { name: 'MCN操控网红人设', count: 145600, slug: 'mcn-jigou-neibu-jilu' },
  { name: '品牌代言人被替换', count: 267890, slug: 'resou-diyan-daiyanren-tihuan' },
];

export const userComments = [
  {
    id: 1,
    name: '吃瓜不嫌事大',
    avatar: '🍉',
    comment: '这个瓜太炸了！我就说这个圈子没一个干净的，坐等后续更多猛料爆出来！',
    likes: 2345,
  },
  {
    id: 2,
    name: '理性吃瓜群众',
    avatar: '🧐',
    comment: '看了前后对比图确实变化挺大的，但也不能排除化妆和滤镜的因素，大家理性吃瓜。',
    likes: 1876,
  },
  {
    id: 3,
    name: '八卦小能手',
    avatar: '🍿',
    comment: '早就听说这件事了，一直没实锤，现在终于有人站出来了，必须顶！',
    likes: 3210,
  },
  {
    id: 4,
    name: '深夜吃瓜人',
    avatar: '🌙',
    comment: '凌晨三点不睡觉就是为了等这个瓜，值了值了！明天上班再说吧！',
    likes: 4567,
  },
  {
    id: 5,
    name: '娱乐圈观察家',
    avatar: '🔍',
    comment: '这种操作在圈内已经是公开的秘密了，只是没人敢说。这位勇士值得尊敬！',
    likes: 2891,
  },
  {
    id: 6,
    name: '热度追踪器',
    avatar: '🔥',
    comment: '果然上热搜了，我就知道这事压不住。继续蹲后续！',
    likes: 1678,
  },
];

export const siteInfo = {
  name: '黑料吃瓜网',
  description: '全网最新热点黑料、网红大瓜、明星八卦实时更新平台。每日追踪娱乐圈、网红圈、互联网圈最新动态，为广大吃瓜群众提供最新鲜、最热门的八卦资讯。',
  email: 'admin@chigua.example.com',
  phone: '400-888-0000',
  address: '中国·互联网吃瓜基地',
  socialLinks: {
    weibo: '#',
    wechat: '#',
    douyin: '#',
    xiaohongshu: '#',
  },
  stats: {
    dailyPosts: '1000+',
    coverage: '99%',
    updateFrequency: '7×24h',
  },
};